import { useBrowserSessionAndLocalState } from "rylak-common/src/hooks/useBrowserState.jsx";
import { SESSION_STORE_KEYS } from "~/constants";
import { ENVIRONMENTS, HOSTS } from "rylak-common";

export function useSelectedBackendHost() {
    return useBrowserSessionAndLocalState({
        defaultValue: ENVIRONMENTS.DEV,
        key: SESSION_STORE_KEYS.KEY_HOST,
        approvedFn: (v) => HOSTS[v],
    });
}
